import { Coords, fitBounds } from 'google-map-react';
import { camelize } from '../utils/utils';

const evtNames = ['click', 'mouseout', 'mouseover'];

interface PolygonParams {
  fillColor?: string,
  fillOpacity?: number,
  paths?: Array<Coords>,
  strokeColor?: string,
  strokeOpacity?: number,
  strokeWeight?: number,
  [key: string]: any
}

export const PolygonUtils = (googleApi: any, map: any) => {
  const defaultParams: PolygonParams = {
    fillColor: '#1E824C',
    fillOpacity: 0.25,
    paths: [],
    strokeColor: '#1E824C',
    strokeOpacity: 1,
    strokeWeight: 4,
  };

  const defaultEventHandlers: {[key: string]: (params?: any, polygon?: any, infoWindow?: any, event?: any) => void} = {
    onMouseout: (params:any, polygon:any) => {
      polygon.setOptions({
        strokeWeight: 2
      });
    },
    onMouseover: (params: any, polygon: any) => {
      polygon.setOptions({
        strokeWeight: 4
      });
    },

    onClick: (params: any, polygon: any, infoWindow: any, event: any) => {
      infoWindow.setPosition(event.latLng);
      infoWindow.open(map);
    }
  }

  const polygonPool: { [key: string]: any } = {};

  const handleEvent = (evt: string, polygon: any, polygonParams: PolygonParams, infoWindow: any) => {
    return (e: DocumentEventMap) => {
      const evtName = `on${camelize(evt)}`
      defaultEventHandlers[evtName](polygonParams, polygon, infoWindow, e);
      if (polygonParams[evtName]) {
        polygonParams[evtName](polygonParams, polygon, infoWindow, e);
      }
    }
  };

  const fitBoundsAndPanTo = (paths: any) => {
    const bounds = new googleApi.LatLngBounds();

    const boundsInit = (point: any) => (
      Array.isArray(point)
        ? point.forEach(boundsInit)
        : bounds.extend(new googleApi.LatLng(point.lat, point.lng)));

    boundsInit(paths);
    map.fitBounds(bounds);
    map.panToBounds(bounds);
  }

  const getAllPolygon = () => polygonPool;
  const getPolygon = (id: string) => polygonPool[id];

  const cleanPolygon = (id: string) => {
    const polygon = polygonPool[id];
    if (polygon) {
      polygon.setMap(null);
      polygon.infoWindow.close();
      delete polygonPool[id];
    }
  };

  const renderPolygon = (id: string, params: PolygonParams, infoWindowContent: any) => {
    console.log('render polygon')

    const polygonParams: PolygonParams = {};
    Object.assign(polygonParams, defaultParams);
    Object.assign(polygonParams, params);

    if (!googleApi) {
      return null;
    }

    console.log('google api:', googleApi)
    console.log('polygon params:', polygonParams)
    const polygon = new googleApi.Polygon(polygonParams);
    polygon.infoWindow = new googleApi.InfoWindow({
      content: infoWindowContent,
      minWidth: 330,
      maxWidth: 380
    });

    polygonPool[id] = polygon;

    polygon.setMap(map);

    evtNames.forEach(eventName => {
      polygon?.addListener(eventName, handleEvent(eventName, polygon, polygonParams, polygon.infoWindow));
    });
  }

  return {
    cleanPolygon,
    renderPolygon,
    getAllPolygon,
    getPolygon,
    fitBoundsAndPanTo,
  };
}
